export var FulfillmentType;
(function (FulfillmentType) {
    FulfillmentType["UNSPECIFIED_FULFILLMENT_TYPE"] = "UNSPECIFIED_FULFILLMENT_TYPE";
    FulfillmentType["DELIVERY"] = "DELIVERY";
    FulfillmentType["PICKUP_OR_DINE_IN"] = "PICKUP_OR_DINE_IN";
})(FulfillmentType || (FulfillmentType = {}));
export var Platform;
(function (Platform) {
    Platform["UNSPECIFIED_PLATFORM"] = "UNSPECIFIED_PLATFORM";
    Platform["SITE"] = "SITE";
    Platform["MOBILE_SITE"] = "MOBILE_SITE";
    Platform["WIX_APP"] = "WIX_APP";
    Platform["CALL_CENTER"] = "CALL_CENTER";
    Platform["CHAT_BOT"] = "CHAT_BOT";
})(Platform || (Platform = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["UNDEFINED"] = "UNDEFINED";
    DayOfWeek["SUN"] = "SUN";
    DayOfWeek["MON"] = "MON";
    DayOfWeek["TUE"] = "TUE";
    DayOfWeek["WED"] = "WED";
    DayOfWeek["THU"] = "THU";
    DayOfWeek["FRI"] = "FRI";
    DayOfWeek["SAT"] = "SAT";
})(DayOfWeek || (DayOfWeek = {}));
export var DishOptionType;
(function (DishOptionType) {
    DishOptionType["UNSPECIFIED_DISH_OPTION_TYPE"] = "UNSPECIFIED_DISH_OPTION_TYPE";
    DishOptionType["SELECTION"] = "SELECTION";
    DishOptionType["EXTRAS"] = "EXTRAS";
    DishOptionType["DESELECTION"] = "DESELECTION";
})(DishOptionType || (DishOptionType = {}));
export var Type;
(function (Type) {
    Type["UNSPECIFIED_ITEM_TYPE"] = "UNSPECIFIED_ITEM_TYPE";
    Type["DISH"] = "DISH";
    Type["VARIATION"] = "VARIATION";
})(Type || (Type = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["UNSPECIFIED_TYPE"] = "UNSPECIFIED_TYPE";
    DiscountType["OFF_ITEM"] = "OFF_ITEM";
    DiscountType["OFF_ORDER"] = "OFF_ORDER";
})(DiscountType || (DiscountType = {}));
export var DiscountPlatform;
(function (DiscountPlatform) {
    DiscountPlatform["UNSPECIFIED_PLATFORM"] = "UNSPECIFIED_PLATFORM";
    DiscountPlatform["SITE"] = "SITE";
    DiscountPlatform["MOBILE_SITE"] = "MOBILE_SITE";
    DiscountPlatform["CALL_CENTER"] = "CALL_CENTER";
})(DiscountPlatform || (DiscountPlatform = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=types.impl.js.map